import script from "./DepartmentInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./DepartmentInfo.vue?vue&type=script&setup=true&lang=ts"

import "./DepartmentInfo.vue?vue&type=style&index=0&id=9d7a1902&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d7a1902"]])

export default __exports__